// extracted by mini-css-extract-plugin
export default {"certificate-image":"certificate-image__6fnzu","image-container":"image-container__mTxty","tools":"tools__t4zLg","empty-image":"empty-image__ZBU5D","row":"row__oZIxe"};